(function () {
  var SCROLL_DOWN_THRESHOLD = 10;
  var SCROLL_UP_THRESHOLD = 12;
  var HIDE_MIN_SCROLL_DEFAULT = 120;
  var HIDE_MIN_SCROLL_BUFFER = 64;

  function getHideMinScrollY(wrapper) {
    if (!wrapper) return HIDE_MIN_SCROLL_DEFAULT;

    var attr = wrapper.getAttribute('data-hide-min-scroll');
    if (attr != null && attr !== '') {
      var parsed = parseInt(attr, 10);
      if (!isNaN(parsed) && parsed >= 0) return parsed;
    }

    return Math.max(HIDE_MIN_SCROLL_DEFAULT, wrapper.offsetHeight + HIDE_MIN_SCROLL_BUFFER);
  }

  function getMobileDrawer() {
    return document.getElementById('ChakrikkaMobileMenuDrawer');
  }

  function closeMobileMenu() {
    var drawer = getMobileDrawer();
    if (drawer && typeof drawer.close === 'function') drawer.close();
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getMegaMenu() {
    return document.querySelector('chakrikka-mega-menu');
  }

  function closeMegaMenu() {
    var mega = getMegaMenu();
    if (mega && typeof mega.close === 'function') mega.close();
  }

  function shouldBlockHide(header) {
    if (!header) return true;
    var drawer = getMobileDrawer();
    if (drawer && drawer.classList.contains('active')) return true;
    var mega = getMegaMenu();
    if (mega && mega.isOpen) return true;
    if (header.querySelector('.header__search details[open]')) return true;
    return false;
  }

  function initHeader(root) {
    var scope = root || document;
    var header = scope.querySelector('[data-chakrikka-header]');
    if (!header) return;

    var wrapper = header.closest('.chakrikka-header-wrapper');
    var mobileDrawer = getMobileDrawer();
    var mobileTrigger = header.querySelector('[data-mobile-menu-trigger]');
    var lastScrollY = window.scrollY;
    var hideOnScrollEnabled = !wrapper || wrapper.getAttribute('data-hide-on-scroll') !== 'false';
    var hideMinScrollY = getHideMinScrollY(wrapper);

    if (mobileTrigger && mobileDrawer && !mobileTrigger.dataset.chakrikkaMenuBound) {
      mobileTrigger.dataset.chakrikkaMenuBound = 'true';
      mobileTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (mobileDrawer.classList.contains('active')) {
          mobileDrawer.close();
        } else {
          mobileDrawer.open(mobileTrigger);
        }
      });
    }

    function syncScrollState() {
      if (!wrapper) return;
      wrapper.classList.toggle('is-scrolled', window.scrollY > 24);
    }

    function syncHideOnScroll() {
      if (!wrapper || !hideOnScrollEnabled || prefersReducedMotion()) {
        if (wrapper) wrapper.classList.remove('is-header-hidden');
        return;
      }

      if (shouldBlockHide(header)) {
        wrapper.classList.remove('is-header-hidden');
        lastScrollY = window.scrollY;
        return;
      }

      var y = window.scrollY;
      var delta = y - lastScrollY;
      lastScrollY = y;

      if (y < hideMinScrollY) {
        wrapper.classList.remove('is-header-hidden');
        return;
      }

      if (delta > SCROLL_DOWN_THRESHOLD) {
        wrapper.classList.add('is-header-hidden');
      } else if (delta < -SCROLL_UP_THRESHOLD) {
        wrapper.classList.remove('is-header-hidden');
      }
    }

    function onScroll() {
      syncScrollState();
      syncHideOnScroll();
    }

    function onResize() {
      hideMinScrollY = getHideMinScrollY(wrapper);
      if (window.innerWidth >= 990) {
        closeMobileMenu();
      }
      if (window.innerWidth < 990) {
        closeMegaMenu();
      }
      syncHideOnScroll();
    }

    syncScrollState();
    syncHideOnScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    document.addEventListener('keyup', function (event) {
      if (event.code === 'Escape') {
        closeMobileMenu();
        closeMegaMenu();
      }
    });

    window.addEventListener('resize', onResize);

    var searchDetails = header.querySelector('.header__search details');
    if (searchDetails) {
      searchDetails.addEventListener('toggle', function () {
        if (searchDetails.open) closeMegaMenu();
      });
    }
  }

  function boot() {
    initHeader(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHeader(event.target);
  });
})();
